import { Component } from '@angular/core';
import {AtestadoModel} from "../../models/atestado.model";
import {SharedMarcacaoService} from "../../services/shared-marcacao.service";
import {AtestadoService} from "../../services/atestado.service";
import {NumeroParaHoraPipe} from "../../pipes/numero-para-hora.pipe";
import {Cid10Model, Cid10PrimaryKey} from "../../models/cid10.model";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Cid10Service} from "../../services/cid10.service";
import {ToastrService} from "ngx-toastr";
import {MarcacaoModel} from "../../models/marcacao.model";
import {PrintService} from "../../services/print.service";
import {MedicoService} from "../../services/medico.service";
import {AuthTokenService} from "../../services/auth-token.service";
import {MedicoModel} from "../../models/medico.model";

@Component({
  selector: 'app-atestados',
  templateUrl: './atestados.component.html',
  styleUrls: ['./atestados.component.scss']
})
export class AtestadosComponent {
  protected numeroGuia: number | undefined;
  protected marcacaoAtual: MarcacaoModel = new MarcacaoModel();
  protected atestados: AtestadoModel[] = [];
  protected atestadoSelecionado: AtestadoModel = new AtestadoModel();
  protected tiposAtestado: string[] = [];
  protected codigosCid: Cid10Model[] = [];
  protected codigoCid: string = '';
  private pipe = new NumeroParaHoraPipe();
  private medico: MedicoModel | undefined;

  constructor(private sharedMarcacaoService: SharedMarcacaoService,
              private modalService: NgbModal,
              private cid10Service: Cid10Service,
              private printService: PrintService,
              private toastrService: ToastrService,
              private medicoService: MedicoService,
              private authTokenService: AuthTokenService,
              protected atestadoService: AtestadoService) {
    this.tiposAtestado = this.atestadoService.obterTiposAtestado();
    this.sharedMarcacaoService.marcacaoAtual.subscribe((res) => {
      this.marcacaoAtual = res ?? new MarcacaoModel();
      this.numeroGuia = res?.numero_Guia;
      this.obterAtestados(this.numeroGuia);
      this.atestadoSelecionado.seq = -1;
    });

    const medicoId = this.authTokenService.medicoId;
    this.medicoService.get(medicoId!).subscribe((res) => {
      this.medico = res.data;
    });
  }

  protected obterAtestados(numeroGuia: number | undefined) {
    if (numeroGuia == undefined) {
      this.atestados = [];
    } else {
      this.atestadoService.getAllByNumeroGuia(numeroGuia).subscribe(res => {
        this.atestados = res.data;
        if (res.data.length == 0) {
          this.setAtestadoAtual(new AtestadoModel());
          this.atestadoSelecionado.seq = -1;
        } else {
          this.setAtestadoAtual(res.data[0]);
        }
      });
    }
    this.codigoCid = '';
  }

  protected setAtestadoAtual(atestado: AtestadoModel) {
    this.atestadoSelecionado = this.transformarAtestado(atestado);
    if (atestado.seq_Cid == undefined) {
      this.codigoCid = '';
      return;
    }

    const pk = Object.assign(new Cid10PrimaryKey(), { seq_Cid: atestado.seq_Cid });
    this.cid10Service.get(pk).subscribe(res => {
      this.codigoCid = res.data?.cid_10 ?? '';
      this.atestadoSelecionado.seq_Cid = res.data?.seq_Cid;
      this.atestadoSelecionado.cid10 = res.data;
    });
  }

  private transformarAtestado(atestado: AtestadoModel): AtestadoModel {
    atestado.hora_Inicial_Atd = this.pipe.transform(atestado.hora_Inicial_Atd);
    atestado.hora_Final_Atd = this.pipe.transform(atestado.hora_Final_Atd);
    return atestado;
  }

  protected abrirModal(content: any) {
    if (this.codigoCid == '' && this.atestadoSelecionado != null) {
      this.atestadoSelecionado.seq_Cid = undefined;
      return;
    }

    this.cid10Service.getByCid10(this.codigoCid).subscribe((res) => {
      this.codigosCid = res.data;
      this.modalService.open(content, { centered: false, windowClass: 'full-screen-modal', backdrop: 'static' });
    });
  }

  protected selecionarCid(cid: Cid10Model) {
    this.codigoCid = cid.cid_10;
    if (this.atestadoSelecionado != null) {
      this.atestadoSelecionado.seq_Cid = cid.seq_Cid;
      this.atestadoSelecionado.cid10 = cid;
    }
  }

  protected novo() {
    if (this.numeroGuia == undefined || this.numeroGuia == 0) {
      this.toastrService.warning('Selecione um atendimento para criar um atestado.', 'Atenção');
      return;
    }

    this.atestadoSelecionado = new AtestadoModel();
    this.atestadoSelecionado.numero_Guia = this.numeroGuia;
    this.codigoCid = '';
  }

  protected salvar() {
    if (this.atestadoSelecionado.seq > 0) {
      this.atualizar();
    } else {
      this.criar();
    }
  }

  private criar() {
    this.atestadoService.create(this.atestadoSelecionado).subscribe(res => {
      this.obterAtestados(this.numeroGuia);
      this.atestadoSelecionado = res.data;
    });
  }

  private atualizar() {
    this.atestadoService.update(this.atestadoSelecionado).subscribe(res => {
      this.obterAtestados(this.numeroGuia);
      this.atestadoSelecionado = res.data;
    });
  }

  protected excluir() {
    this.atestadoService.delete(this.atestadoSelecionado).subscribe(res => {
      this.obterAtestados(this.numeroGuia);
      this.atestadoSelecionado = new AtestadoModel();
    });
  }

  protected imprimir() {
   if (!this.marcacaoAtual?.isTravada && (!this.atestadoSelecionado.motivo_Declaracao || this.atestadoSelecionado.motivo_Declaracao.trim() === '')) {
    alert('O campo Motivo Declaração é obrigatório.');
    return;
  }
    this.printService.printAtestado(this.atestadoSelecionado, this.marcacaoAtual, this.medico!);
  }
}
